"use client";

import { SurveyQuestionResponse } from "@yardzen/api-dtos";
import { IconName } from "@yardzen/ui/components/icon";
import { Input } from "@yardzen/ui/components/input";
import {
  UseFormGetValues,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import { MultipleChoiceResponseType } from "../QuizQuestionHandler";
import { ResponseOptions } from "./ResponseOptions";

export default function MultipleChoiceResponse({
  options,
  surveyQuestionResponse,
  fields,
  register,
  setValue,
  getValues,
}: {
  options: {
    text: string;
    value: string;
    icon: IconName;
  }[];
  fields?: {
    key: string;
    label: string;
    maxLength?: number;
  }[];
  surveyQuestionResponse?: SurveyQuestionResponse;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
}) {
  const response: MultipleChoiceResponseType | null =
    surveyQuestionResponse?.response
      ? (JSON.parse(
          surveyQuestionResponse.response,
        ) as MultipleChoiceResponseType)
      : null;

  const currentValues = getValues("values") || [];

  const handleTogglePress = (value: string, pressed: boolean) => {
    const newValues = pressed
      ? [...currentValues, value.toString()]
      : currentValues.filter((v: string) => v !== value.toString());

    // Only update if the value actually changes
    if (pressed !== currentValues.includes(value.toString())) {
      setValue("values", newValues, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  return (
    <div className="w-full p-2">
      <div className="flex w-full flex-wrap justify-center gap-2">
        <ResponseOptions
          options={options}
          responseType="multiple-choice"
          onOptionPress={handleTogglePress}
          isSelected={(value) => currentValues.includes(value.toString())}
          register={register("values")}
        />
      </div>
      {fields?.map((field) => {
        return (
          <Input
            key={field.key}
            type="text"
            {...register(field.key)}
            maxLength={field.maxLength}
            placeholder={field.label}
            className="mt-4 w-full rounded-md"
            defaultValue={
              response?.fields?.find((f) => f.key === field.key)?.value || ""
            }
          />
        );
      })}
    </div>
  );
}
